export const Permission = {
    ACCOUNTS: 'accounts',
};
